import { ref } from 'vue';
import getJWT from '../../lib/getJWT';

type JWT = ReturnType<typeof getJWT>;
const jwt = ref<JWT | null>(null);

export const updateJWT = () => {
  try {
    jwt.value = getJWT();
  } catch (e) {
    jwt.value = null;
  }
};

export default function useJWT() {
  return { jwt };
}
